export const mimeType = [
  { svg: 'docs', accept: ['docs'] },
  { svg: 'html', accept: ['html'] },
  { svg: 'jpg', accept: ['image/jpeg', 'image/png', 'image/svg+xml'] },
  { svg: 'mp3', accept: ['mp3'] },
  { svg: 'exe', accept: ['application/x-msdownload'] },
  { svg: 'pdf', accept: ['application/pdf'] },
  {
    svg: 'ppt',
    accept: [
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
  },
  { svg: 'zip', accept: ['application/x-zip-compressed'] },
  { svg: 'xls', accept: ['xls', 'csv', 'xlsx'] },
  { svg: 'rar', accept: ['rar'] },
  { svg: 'folder', accept: ['application/vnd.google-apps.folder'] },
];
